module.exports = "<div class=\"login-header header-holder\">\n  <h1 class=\"logo\"><%= i18n.openEnglish %></h1>\n\n  <h2 class=\"welcome-message\"><%= i18n.login.welcomeBack %></h2>\n  <nav></nav>\n  <ul class=\"top-nav\">\n    <li id=\"login-support\"></li>\n    <a id=\"login2-return\" style=\"display:none\" href=\"<%= loginUrl %>\"><strong><%= i18n.login.LoginReturn %></strong></a>\n  </ul>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./js/login/templates/Header.html
// module id = 716
// module chunks = 26